import type { GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'

export function hasChildFields(field: GeneratedSchemaField): field is GeneratedSchemaField & {
  fields: GeneratedSchemaField[]
} {
  return Array.isArray(field.fields)
}
